import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Shared Spinner component for consistent loading indicators across the app.
 *
 * @param {'xs' | 'sm' | 'md' | 'lg'} size - Spinner size (default: 'md')
 * @param {'primary' | 'inverse' | 'success'} variant - Color variant (default: 'primary')
 * @param {string} className - Additional classes
 */
const SIZE_CLASSES = {
  xs: 'h-4 w-4 border-2',
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]',
};

const VARIANT_CLASSES = {
  primary: 'border-primary/20 border-t-primary',
  inverse: 'border-white/30 border-t-white',
  success: 'border-success/20 border-t-success',
};

function Spinner({ size = 'md', variant = 'primary', className = '' }) {
  const { t } = useTranslation();
  return (
    <div
      className={`animate-spin rounded-full ${SIZE_CLASSES[size] || SIZE_CLASSES.md} ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary} ${className}`}
      role="status"
      aria-label={t('spinner.ariaLabel')}
    >
      <span className="sr-only">{t('spinner.srText')}</span>
    </div>
  );
}

export default Spinner;
